module.exports = __webpack_public_path__ + "img/barn.3219dd21.svg";